module.exports = __webpack_public_path__ + "static/media/keras_logo.c309c4c6.png";